import { getDelta } from "./Side";
export class Cursor {
    constructor(p) {
        this.x = p.x;
        this.y = p.y;
    }
    step(side, mag = 1) {
        const { x: dx, y: dy } = getDelta(side);
        this.x += dx * mag;
        this.y += dy * mag;
        return this;
    }
    fork() {
        return new Cursor(this);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/Cursor.ts
// module id = 3
// module chunks = 0